import BenchlingConfig from 'BenchlingConfig';
import ProcedureHeaderActionButtons from 'procedures/design/ProcedureHeaderActionButtons';
import ProcedureTemplateCollectibleBadge from 'procedures/design/ProcedureTemplateCollectibleBadge';
import {
  ProcedureValidationError,
  ProcedureValidationObjectType,
  ProcedureValidationErrorType,
} from 'procedures/design/validation/ProcedureValidationTypes';
import ProcedureMethodNodeAdapter from 'procedures/processes/ProcedureMethodNodeAdapter';
import {ProcessFlowchartNodeAdapter} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {FlowchartValidator} from 'processes/graph-builder-processes/platform/FlowchartValidator';
import {
  ProcessesPluginBase,
  ProcessesPluginMetadataEditorItem,
} from 'processes/graph-builder-processes/platform/ProcessesPluginBase';
import {ProcessFlowchartConfigEditorHeaderConfig} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/ProcessFlowchartConfigEditorHeaderTypes';

import ProcedureFlowchartValidator from './ProcedureFlowchartValidator';
import ProcedureRootNodeAdapter from './ProcedureRootNodeAdapter';

export class ProcedureProcessesPlugin extends ProcessesPluginBase {
  static readonly FLOWCHART_TYPE_NAME = 'PROCEDURE_FLOWCHART';

  readonly pluginName: string = 'Procedures Plugin';
  readonly flowchartTypeName: string = ProcedureProcessesPlugin.FLOWCHART_TYPE_NAME;

  readonly nodeAdapters: Array<ProcessFlowchartNodeAdapter> = [
    new ProcedureMethodNodeAdapter(),
    new ProcedureRootNodeAdapter(),
  ];

  readonly flowchartValidator: FlowchartValidator<
    ProcedureValidationError,
    ProcedureValidationErrorType,
    ProcedureValidationObjectType
  > = new ProcedureFlowchartValidator();
  readonly metadataEditor?: ProcessesPluginMetadataEditorItem = undefined;

  override readonly headerConfig: ProcessFlowchartConfigEditorHeaderConfig = {
    icon: 'list',
    breadcrumbItems: [], // TODO (BNCH-141293): Link to template collection
    headerLeftContent: BenchlingConfig.ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE
      ? ProcedureTemplateCollectibleBadge
      : undefined,
    actionsComponent: ProcedureHeaderActionButtons,
    // TODO (BNCH-141293): Implement displayName and onRename
  };
}
